import { render, staticRenderFns } from "./ProfileOverview.vue?vue&type=template&id=21373ff2&"
import script from "./ProfileOverview.vue?vue&type=script&lang=js&"
export * from "./ProfileOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21373ff2')) {
      api.createRecord('21373ff2', component.options)
    } else {
      api.reload('21373ff2', component.options)
    }
    module.hot.accept("./ProfileOverview.vue?vue&type=template&id=21373ff2&", function () {
      api.rerender('21373ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Profile/ProfileOverview.vue"
export default component.exports